module.exports = __webpack_public_path__ + "img/Perdues@1x.4dbce5e2.webp";